module.exports = __webpack_public_path__ + "img/xid-grey.0671d79c.svg";